export const KYSELY_MODULE_CONNECTION_TOKEN = (namespace?: string) =>
  `KyselyModuleConnectionToken${namespace ? "_" + namespace : ""}`;
export const KYSELY_MODULE_OPTIONS_TOKEN = "KyselyModuleOptionsToken";
